
import React from 'react';
import { CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle2 } from 'lucide-react';

const AssessmentCompleteBanner: React.FC<{
  title: string;
}> = ({ title }) => {
  return (
    <>
      <CardHeader className="bg-gradient-to-r from-[#e87a2e] to-[#f97316] text-white rounded-t-lg">
        <CardTitle className="text-2xl">Assessment Preview Complete!</CardTitle>
        <CardDescription className="text-white/90">
          Thank you for completing the {title} Preview! If you want access to the full assessment, please click on the "Request Premium Access" button at the end of the page.
        </CardDescription>
      </CardHeader>
      
      <div className="flex justify-center mb-6 pt-6">
        <div className="w-16 h-16 bg-[#e87a2e]/10 rounded-full flex items-center justify-center">
          <CheckCircle2 className="h-8 w-8 text-[#e87a2e]" />
        </div>
      </div>

      <div className="text-center mb-8">
        <h2 className="text-xl font-medium mb-2">Your Assessment Results</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Below is a summary of your current maturity level and recommendations for improvement. 
          You can download the full report or schedule a call with our experts for a detailed analysis.
        </p>
      </div>
    </>
  );
};

export default AssessmentCompleteBanner;
